import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	rail: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		flexShrink: 0,
		gap: SPACE[4],
		paddingBottom: SPACE[16],
	},
	folder: {
		gap: SPACE[4],
		border: THEME.common.border,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	folderSelected: {
		borderColor: THEME.colors.primary.main,
		backgroundColor: THEME.colors.hover.light,
		color: THEME.colors.primary.main,
	},
});
